import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import routes from 'store/configs/Routes';
import AccountRoutes from 'components/account/AccountRoutes';
import CustomerDownloadComponent from 'components/customerDownload/CustomerDownloadComponent';
import HomeComponent from 'components/home/HomeComponent';
import MainPageLayout from 'components/layouts/MainPageLayout';
import LoginComponent from 'components/LoginComponent';
import LogoutComponent from 'components/LogoutComponent';
import MeetingListPage from 'components/meetings/MeetingListPage';
import NotFoundComponent from 'components/NotFoundComponent';
import StandardsBallotRoutes from 'components/standardsBallots/StandardsBallotRoutes';
import MeetingPage from 'components/meetings/MeetingPage';

const AppRoutes: React.FunctionComponent = () => {
  return (
    <Router>
      <Routes>
        <Route element={<MainPageLayout />}>
          <Route path={routes.root} element={<Navigate to={routes.home} />} />
          <Route path={routes.home} element={<HomeComponent />} />
          <Route path={`${routes.account.root}/*`} element={<AccountRoutes />} />
          {/* Committees are now under account */}
          {/* <Route path={`${routes.account.committees}/*`} element={<CommitteeRoutes />} /> */}
          <Route path={routes.login} element={<LoginComponent />} />
          <Route path={routes.logout} element={<LogoutComponent />} />
          <Route path={`${routes.standardsBallot.root}/*`} element={<StandardsBallotRoutes />} />
          <Route path={routes.productDownload} element={<CustomerDownloadComponent />} />
          <Route path={routes.meetings} element={<MeetingListPage />} />
          <Route path={routes.meeting} element={<MeetingPage />} />
        </Route>
        <Route path="*" element={<NotFoundComponent />} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
